import { createStateSelectorHook } from 'src/lib/sweetState';
import { useCurrentWorkspace } from 'src/store';
import { PerformanceStore } from './PerformanceStore';
import { useMemo } from 'react';

const usePerformanceState = createStateSelectorHook(PerformanceStore, [
  'globalBenchmarkConfig',
  'loadingGlobalBenchmark',
]);

export const useGlobalBenchmarkConfig = () => {
  const { globalBenchmarkConfig, loadingGlobalBenchmark } = usePerformanceState();
  const currentWorkspace = useCurrentWorkspace();

  const workspaceAssociatedAccountIds = (currentWorkspace?.associatedAccounts || []).map(
    (account) => account.accountId
  );

  return useMemo(
    () => ({
      globalBenchmarkConfig: globalBenchmarkConfig?.filter((c) =>
        workspaceAssociatedAccountIds.includes(c.account.id)
      ),
      loadingGlobalBenchmark,
    }),
    [globalBenchmarkConfig, workspaceAssociatedAccountIds, loadingGlobalBenchmark]
  );
};
